import React from 'react';
import './UrinEnergy.css';
import urinImage from './img/logo.jpeg';
import styled from 'styled-components';
import flowUrinEnergy from './img/flow.jpg';

import { Animated } from 'react-animated-css';


const ArrowWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 350px;
  height: 350px;
`;

const ArrowRight = styled.svg`
  width: 40%;
  height: 40%;
  fill: #38eb92ff;
`;

const Text = styled.div`
  font-size: 35px;
  font-weight: bold;
  color: black;
  font-family: 'Poppins', sans-serif;
  font-style: italic;
`;


function UrinEnergy() {
    const handleWhatsAppClick = () => {
        window.location.href = 'https://wa.me/593959736777';
    }

    return (
        <>
            <header className="header-container">
                <div className="title-image-container">
                    <Animated animationIn="fadeIn" isVisible={true}>
                        <h1 className="UrinEnergy-title">UrinEnergy</h1>
                    </Animated>
                    <Animated animationIn="fadeInUp" isVisible={true}>
                        <img className="header urinImage" src={urinImage} alt="UrinEnergy logo" />
                    </Animated>
                </div>
                <div className="button-container">
                    <Animated animationIn="fadeIn" isVisible={true}>
                        <button className="UrinEnergy-button" onClick={handleWhatsAppClick}>Más información</button>
                    </Animated>
                </div>
            </header>
            <header className="header-containerTwo">
                <header className="header-container3">
                    <ArrowWrapper>
                        <ArrowWrapper>
                            <ArrowRight viewBox="0 0 24 24">
                                <path d="M16.59 11H4c-.55 0-1 .45-1 1s.45 1 1 1h12.59l-3.29 3.29c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0l5.59-5.59c.39-.39.39-1.02 0-1.41l-5.59-5.59c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L16.59 11z" />
                            </ArrowRight>
                        </ArrowWrapper>
                        <Text>Flow</Text>
                        <ArrowWrapper>
                            <ArrowRight viewBox="0 0 24 24">
                                <path d="M16.59 11H4c-.55 0-1 .45-1 1s.45 1 1 1h12.59l-3.29 3.29c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0l5.59-5.59c.39-.39.39-1.02 0-1.41l-5.59-5.59c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L16.59 11z" />
                            </ArrowRight>
                        </ArrowWrapper>
                    </ArrowWrapper>
                </header>

                <div className="image-header-flow">
                    <img src={flowUrinEnergy} alt="Descripción de la imagen" />
                </div>
                <div className="hero">
                    <div className="hero-text"> <Animated animationIn="fadeIn" isVisible={true}>
                        <p className="UrinEnergy-description">
                            En UrinEnergy, creemos que la orina es una fuente de energía renovable y limpia para empresas. Utilizamos una celda seca para separar la orina y producir hidrógeno, que luego se puede utilizar para generar energía.
                        </p>
                    </Animated>
                    </div>
                </div>
            </header>
            {/* Header */}

            <div className="hero"></div>
            <div className="hero"></div>

            <div className="hero">
                <div className="hero-text">
                    <Animated animationIn="fadeIn" isVisible={true}>
                        <h1 className="UrinEnergy-subtitle">¿Qué es UrinEnergy?</h1>
                    </Animated>
                    <Animated animationIn="fadeIn" delay={500} isVisible={true}>
                        <p className="UrinEnergy-description">
                            UrinEnergy es el medio para que las empresas puedan devolver la energía que toman del ambiente mediante una obtención limpia y renovable a partir de la orina.
                        </p>
                    </Animated>
                    <Animated animationIn="fadeIn" delay={1000} isVisible={true}>
                        <p className="UrinEnergy-description">
                            Nuestra tecnología utiliza una celda seca para separar el hidrógeno de la orina y producir energía eléctrica.
                        </p>
                    </Animated>
                    <Animated animationIn="fadeIn" delay={1500} isVisible={true}>
                        <button className="UrinEnergy-button">Más información</button>
                    </Animated>

                </div>
                <div className="hero-image">
                    <Animated animationIn="fadeInRight" isVisible={true}>
                        <img src="./hero-image.png" alt="Hero" />
                    </Animated>
                </div>
            </div>
            <div className="features">
                <div className="features-text">
                    <Animated animationIn="fadeIn" isVisible={true}>
                        <h2 className="UrinEnergy-subtitle">Características</h2>
                    </Animated>
                    <Animated animationIn="fadeIn" delay={500} isVisible={true}>
                        <p className="UrinEnergy-description">
                            La tecnología de UrinEnergy tiene las siguientes características:
                        </p>
                    </Animated>
                </div>

            </div>
            <footer className="UrinEnergy-footer">
                <p>UrinEnergy &copy; 2023</p>
            </footer>


        </>
    );
}

export default UrinEnergy;



